import { WorkflowBlock } from '../../types/Workflow/WorkflowBlock'

export const blockHasApprovers = (block: WorkflowBlock) => block.type === 'APPROVAL' || block.type === 'APPROVER'

export default blockHasApprovers
